/* eslint-disable testing-library/render-result-naming-convention */
/* Copyright (c) 2020-present CloudIO Inc */

import { observable } from '@legendapp/state';
import { useObserve } from '@legendapp/state/react';
import useMounted from 'hooks/useMounted';
import React, { memo } from 'react';
import WaveDots from 'utils/WaveDots';
import { pageProgressPending } from '../../components/Page/PageProgressed';
import GlobalLoader from './GlobalLoader';
import { maskPageSignal } from 'components/Page/MaskPage';

export const loadingSignal = observable({ loadingCount: 0 });

function LoadingIndicator({
  hideWaveDots,
  appUid,
}: {
  appUid: string;
  hideWaveDots?: boolean;
}): React.ReactElement | null {
  const [loading, setLoading] = React.useState(false);
  const mounted = useMounted(false);

  useObserve(() => {
    let loading1 = loadingSignal.loadingCount.get() > 0;
    const pages = pageProgressPending[appUid].get() ?? {};
    const loading2 = Object.values(pages).filter((p) => p).length > 0;
    const loading3 = maskPageSignal.postCount.get() > 0;
    loading1 = loading1 || loading2 || loading3;
    setTimeout(() => {
      if (mounted.current) {
        setLoading(loading1);
      }
    }, 1);
  });

  return (
    <>
      {loading && !hideWaveDots ? (
        <WaveDots active style={{ marginRight: 12 }} />
      ) : null}
      <GlobalLoader isLoading={loading} />
    </>
  );
}

export default memo(LoadingIndicator);
